<template>
  <article class="layout-section -align-side">
    <figure
      class="layout-section__figure"
      style="background-image: url('/images/pexels-diva-plavalaguna-6147031.jpg')"
    />

    <section class="layout-section__content">
      <h2 class="layout-section__title">Section descriptive visuelle</h2>
      <p>
        Ce type de section agit comme un teaser : une image accrocheuse pour susciter l’intérêt, un texte concis pour
        cadrer le message, et un bouton pour accéder à l’information complète. L’image joue ici un rôle stratégique dans
        l’orientation et l’engagement de l’utilisateur.
      </p>
      <button class="button layout-section__cta">
        Bouton
        <SvgIcon id="action-arrow" />
      </button>
    </section>
  </article>
</template>

<script>
export default {
  name: 'DemoContent'
}
</script>
